module.exports = ":host ::ng-deep timezone-picker .wrapper {\n  width: 300px;\n  height: auto;\n}"